import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, length: number, symbol: string): string {
      if (value.length > length) {
          return value.slice(0, length) + symbol;
      }
      return value;
  }
}
